/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

export const BuildingIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = 15,
  height = 15,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="building-icon"
    {...props}
  >
    <rect x="0.5" y="6" width="4.5" height="12" rx="0.3" stroke="currentColor" strokeWidth="1.2" />
    <rect x="1.6" y="7.5" width="1.1" height="1.1" fill="currentColor" />
    <rect x="3.2" y="7.5" width="1.1" height="1.1" fill="currentColor" />
    <rect x="1.6" y="10" width="1.1" height="1.1" fill="currentColor" />
    <rect x="3.2" y="10" width="1.1" height="1.1" fill="currentColor" />
    <rect x="15" y="5" width="4.5" height="13" rx="0.3" stroke="currentColor" strokeWidth="1.2" />
    <rect x="16" y="6.5" width="1.1" height="1.1" fill="currentColor" />
    <rect x="17.7" y="6.5" width="1.1" height="1.1" fill="currentColor" />
    <rect x="16" y="9" width="1.1" height="1.1" fill="currentColor" />
    <rect x="17.7" y="9" width="1.1" height="1.1" fill="currentColor" />
    <rect x="5.5" y="2" width="9" height="16" rx="0.4" stroke="currentColor" strokeWidth="1.5" />
    <rect x="7" y="4.2" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="9.25" y="4.2" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="11.5" y="4.2" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="7" y="7.5" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="9.25" y="7.5" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="11.5" y="7.5" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="7" y="10.8" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="11.5" y="10.8" width="1.5" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="9" y="13.5" width="2" height="4.5" rx="0.2" fill="currentColor" />
  </svg>
);
